import React from "react";
import Game from "./components/Game";
import "./App.css";

const App = () => (
    <>
        <Game />;
    </>
);
export default App;
